import { getRequest, postRequest, patchRequest, deleteRequest } from './http.service';
import {
  URL_USE_GRAPH_SECRET,
  URL_MODELING_MODULES,
  URL_MODELING_CREATE,
  URL_MODELING_UPDATE,
  URL_MODELING_MODULE,
} from './url.service';

export const postGraphSecret = (orgId: string) =>
  postRequest(URL_USE_GRAPH_SECRET, { orgId });

export const fetchModules = () =>
  getRequest(URL_MODELING_MODULES);

export const createModule = (payload: Record<string, unknown>) =>
  postRequest(URL_MODELING_CREATE, payload);

export const updateModule = (moduleId: string, payload: Record<string, unknown>) =>
  patchRequest(URL_MODELING_UPDATE(moduleId), payload);

export const deleteModule = (moduleId: string) =>
  deleteRequest(URL_MODELING_MODULE(moduleId));
